import { EventType } from "../../../siteManagement/eventManager.js"
import { General } from "../../../siteManagement/general.js"
import { Sheet, SheetEventType, SheetInteractionEventType } from "../../../siteManagement/sheet.js"
import { StringKeyDictionary } from "../../commonInterfaces.js"
import { Entity, Metadata } from "../../core/components/commonApp.js"
import { DateTimePickerField } from "../../core/components/dateTimePicker.js"
import { Dialog, DialogAction, DialogProps } from "../../core/components/dialog.js"
import { RightDrawerContainer } from "../../core/components/rightDrawerContainer.js"
import { Slider, SliderField } from "../../core/components/slider.js"
import { TextBox } from "../../core/components/textBox.js"
import { Config } from "../../core/config/config.js"
import { ComponentHelper } from "../../core/util/componentHelper.js"
import { DialogHelper } from "../../core/util/dialogHelper.js"
import { Helper } from "../../core/util/helper.js"
import { HTTPService, JsonResultClass } from "../../core/util/httpManager.js"
import { NotificationHelper } from "../../core/util/notificationHelper.js"
import { DynamicSearchApp, DynamicSearchAppProps, InitialSearchFilterState } from "../../dynamicSearch/dynamicSearch.js"
import { ErrorBoundary } from "../../statistics/components/error_boundary.js"
import { Cartographer } from "../cartographer.js"
import { DirectionsDisplay } from "../components/directions/directionsDisplay.js"
import { PerimeterSearchControls } from "../components/directions/perimeterSearchControls.js"
import { Route } from "../components/directions/route.js"
import { TimeSpanFilter } from "../components/directions/timeSpanFilter.js"
import { Waypoint, WaypointData, WaypointType } from "../components/directions/waypoint.js"
import { Map as GoogleMapsMap } from "../components/map.js"
import { GeomapRPCService, RouteColors } from "../geomapRPCService.js"
import { GeomapService } from "../geomapService.js"
import { GeomapConfig, GeomapEntityType, GeomapUtil, PointInfo, PointType, RouteObject } from "../geomapUtil.js"
import React from "react";
import ReactDOM from "react-dom";
export class DirectionsApp extends React.Component<DirectionsAppProps, any>{
    render() {
        return <ErrorBoundary><DirectionsAppIntern {...this.props}></DirectionsAppIntern></ErrorBoundary>;
    }
}

class DirectionsAppIntern extends React.Component<DirectionsAppProps, DirectionsAppState>{
    private _resourceRoutesView: boolean = false;
    private _currentDropTargetId: number;
    private _currentDropTargetIdx: number;
    private _stopScrolling: boolean;
    private _directionsDiv: HTMLDivElement;
    private _geomapService: GeomapService;
    private _util: GeomapUtil;
    private _srService: GeomapRPCService;
    private _pointsToAdd: Array<{ point: PointInfo, routeId?: number }>;
    private _svgsPrepared: boolean = false;
    private _perimeterSearchApp: DynamicSearchApp;
    private _conversionFactor: number = 1.609344;
    private _sliderRef: Slider;
    private _perimeterSearchSheet: Sheet;
    private _perimeterSearchWaypoints: Array<WaypointData> = [];
    private _sliderTimeoutId: number;
    private _textBoxRef: TextBox;
    private _innoHelper = Helper;
    private _googleMapsDialogRef: Dialog;
    private _googleMapsUrlDialogActions: Array<DialogAction>;
    private _googleMapsUrlDialogProps: DialogProps;
    private _timeSpanFilterDialogActions: Array<DialogAction>;
    private _timeSpanFilterDialogProps: DialogProps;
    private _rightDrawerContainer: any;
    private _currentSheet: Sheet = null;
    private _containerViewDialogActions: Array<DialogAction>;
    private _containerViewDialogProps: DialogProps;
    private _activeResourceAssignmentsViewDialogActions: Array<DialogAction>;
    private _activeResourceAssignmentsViewDialogProps: DialogProps;
    private _contextMenuRef: HTMLDivElement;
    resetToggleState: Map<number, boolean>;
    cartographer: Cartographer;
    private adrnrEntity: any = null;

    private resizeObserver: ResizeObserver = null;
    private resultRef: any;

    constructor(props: DirectionsAppProps) {
        super(props);
        this._geomapService = new GeomapService();
        this._pointsToAdd = [];
        this.resetToggleState = new Map<number, boolean>();
        const containerEnd = this._addDays(new Date(Date.now()), 7);
        this.state = {
            routes: [],
            translations: null,
            distance: this.props.sliderLargeStep,
            isPerimeterSearchTransparent: false,
            pinConfig: null,
            activeResourceAssignmentsViewTimestamp: new Date(Date.now()),
            containerViewTimeSpanStart: new Date(Date.now()),
            containerViewTimeSpanEnd: containerEnd,
            isLiveLocation: false
        };
        this._initResize();
    }

    private _addDays = (date: Date, days: number) => {
        let result = new Date(date.valueOf());
        result.setDate(date.getDate() + days);
        return result;
    }

    private _calculateTimespans = () => {
        let now = Date.now();
        let startResourceFilter = new Date(now);
        let endResourceFilter = new Date(now);
        startResourceFilter.setDate(startResourceFilter.getDate() - this.props.resourceFilterDaysBefore);
        endResourceFilter.setDate(endResourceFilter.getDate() + this.props.resourceFilterDaysAfter);
        startResourceFilter.setHours(0, 0, 0, 0);
        endResourceFilter.setHours(23, 59, 59, 999);

        let startPerimeterSearch = new Date(now);
        let endPerimeterSearch = new Date(now);
        startPerimeterSearch.setDate(startPerimeterSearch.getDate() - this.props.perimeterDaysBefore);
        endPerimeterSearch.setDate(endPerimeterSearch.getDate() + this.props.perimeterDaysAfter);
        startPerimeterSearch.setHours(0, 0, 0, 0);
        endPerimeterSearch.setHours(23, 59, 59, 999);
        return { startResourceFilter: startResourceFilter, endResourceFilter: endResourceFilter, startPerimeterSearch: startPerimeterSearch, endPerimeterSearch: endPerimeterSearch };
    }

    private _initResource = (ressnr: string, routeID: number) => {
        return new Promise((resolve, reject) => {
            if (ressnr != null) {
                this._geomapService.getResourceById(ressnr).then((result: JsonResultClass) => {
                    let waypoints = this._setViewWaypoints([result.Data], routeID, GeomapEntityType.ResourceViewEntity, false);
                    resolve(waypoints);
                }, () => {
                    resolve([]);
                });
            }
            else {
                resolve([]);
            }
        });
    }

    private _initAddressAndAssignment = (assignment: Object, routeID: number) => {
        return new Promise((resolve, reject) => {
            if (this._util.getPropertyByLowerCase(assignment, "adrnr") != null) {
                this._geomapService.getAddressById(this._util.getPropertyByLowerCase(assignment, "adrnr")).then((result: JsonResultClass) => {
                    let waypoints = this._setViewWaypoints([$.extend({}, result.Data, assignment)], routeID, GeomapEntityType.AssignmentViewEntity, false);
                    resolve(waypoints);
                }, () => {
                    resolve([]);
                });
            }
            else {
                let waypoints = this._setViewWaypoints([assignment], routeID, GeomapEntityType.AssignmentViewEntity, false);
                resolve(waypoints);
            }
        });
    }

    private _addToTmpAndSetState = (waypoints: Array<WaypointData>, routeID: number, callback?: () => any) => {
        let routesTmp = this._util.deepCopyArray(this.state.routes);
        waypoints.forEach((entry) => {
            this._innoHelper.getArrayItem(routesTmp, "id", routeID).waypoints.push(entry);
        });
        this._tryToGeocodeWithWaypoints(waypoints, routeID).then(() => {
            this.setState({ routes: routesTmp }, callback ? callback : null);
        });
    }

    private _initRoutes = (type: string, id1: string, id2: number, resourceIDs?: Array<string>, groups?: Array<string>) => {
        switch (type) {
            case 'assignment': return this._initAssignmentAddresses(id1, id2, 1);
            case 'resourceRoutes': return this._initResourceRoutes(resourceIDs, this.props.start ? this.props.start : this.state.resourceFilterTimeSpanStart,
                this.props.end ? this.props.end : this.state.resourceFilterTimeSpanEnd, groups);
            default: break;
        }
    }

    private _initResourceRoutes = (resourceIDs: Array<string>, start: Date, end: Date, groups: Array<string>) => {
        this._resourceRoutesView = true;
        let newID = 1;
        let newState: DirectionsAppState = { routes: [], isLiveLocation: false };
        let promise = new Promise((resolve, reject) => {
            //Container Route
            newState.routes.push({ id: newID, waypoints: [], name: this.state.translations["GeoMap.Container"], hide: true } as RouteObject);

            this._geomapService.getResourcesByIds(resourceIDs).then((result: JsonResultClass) => {
                if (result.Data != null) {
                    result.Data.sort((r1, r2) => {
                        if (r1.Name > r2.Name) {
                            return 1;
                        };
                        if (r1.Name < r2.Name) {
                            return -1;
                        }
                        return 0;
                    });
                    for (let i = 0; i < result.Data.length; i++) {
                        newID += 1;
                        newState.routes.push({ id: newID, waypoints: [], name: `${result.Data[i].Name || ""}, ${result.Data[i].Vorname || ""}`, hide: true, ressNr: result.Data[i].Ressnr } as RouteObject);
                        let waypoint = this._setViewWaypoints(result.Data.slice(i, i + 1), newID, GeomapEntityType.ResourceViewEntity, false, false);
                        this._innoHelper.getArrayItem(newState.routes, "id", newID).waypoints = this._innoHelper.getArrayItem(newState.routes, "id", newID).waypoints.concat(waypoint);
                    }
                }
                return this._geomapService.getAssignmentsByRessNrs(resourceIDs, start, end, groups);
            }).then((result: JsonResultClass) => {
                if (result.Data.length <= 300) {
                    for (let i = 0; i < result.Data.length; i++) {
                        if (result.Data[i].RessNr == null && result.Data[i].Breitegrad != null && result.Data[i].Laengegrad != null && (result.Data[i].Breitegrad !== 0 || result.Data[i].Laengegrad !== 0)) {
                            let waypoint = this._setViewWaypoints(result.Data.slice(i, i + 1), newState.routes[0].id, GeomapEntityType.AssignmentViewEntity, false, false);
                            newState.routes[0].waypoints = newState.routes[0].waypoints.concat(waypoint);
                        }
                        for (let j = 0; j < newState.routes.length; j++) {
                            if (newState.routes[j].waypoints[0] && newState.routes[j].waypoints[0].no === result.Data[i].RessNr
                                && result.Data[i].Breitegrad != null && result.Data[i].Laengegrad != null && (result.Data[i].Breitegrad !== 0 || result.Data[i].Laengegrad !== 0)) {
                                let waypoint = this._setViewWaypoints(result.Data.slice(i, i + 1), newState.routes[j].id, GeomapEntityType.AssignmentViewEntity, false, false);
                                newState.routes[j].waypoints = newState.routes[j].waypoints.concat(waypoint);
                            }
                        }
                    }
                    this._tryToGeocode(newState.routes).then(() => {
                        resolve(newState);
                    });
                }
                else {
                    NotificationHelper.showErrorMessage(this.state.translations["GeoMap.MaximumAmountOfResourcesExceeded"]);
                    reject();
                }
            });
            //}
            //else {
            //    resolve(newState);
            //}
        });

        return promise;
    }

    private _initAssignmentAddresses = (id1: string, id2: number, routeID: number) => {
        let waypointsToAdd = [];
        const promise = new Promise((resolve, reject) => {
            this._geomapService.getAssignment(id1, id2)
                .then((result: JsonResultClass) => {
                    const promiseIR = this._initResource(result.Data.RessNr, routeID);
                    const promiseIAA = this._initAddressAndAssignment(result.Data, routeID);
                    return Promise.all([promiseIR, promiseIAA]);
                }, () => {
                    reject();
                })
                .then((result: void | Array<any>) => {
                    this.setFocusToPins(routeID);
                    waypointsToAdd = result[0].concat(result[1]);
                    resolve(waypointsToAdd);
                }, () => {
                    reject();
                });
        });

        return promise;
    }

    private _setViewWaypoints = (entries: Array<any>, routeID: number, entityType: GeomapEntityType, update: boolean = true, zoom?: boolean, clickCallback?: (...args: any[]) => void) => {
        let waypointsToAdd: Array<WaypointData> = [];
        if (entries != null) {
            this.clearRoute(routeID, () => {
                entries.forEach((e) => {
                    //console.log(e.projnr);
                    let waypoint = this._setWaypoint(
                        this._util.mapToWaypoint(e, entityType, this.state.isLiveLocation),
                        zoom == null ? entries.length === 1 : zoom, routeID, clickCallback);
                    if (waypoint) {
                        //console.log("wp");
                        waypointsToAdd.push(waypoint);
                    }

                });
                if (update) {
                    this._addToTmpAndSetState(waypointsToAdd, routeID);
                }
            });
        }
        else {
            NotificationHelper.showErrorMessage(this.state.translations["GeoMap.AddressNotFound"]);
        }
        return waypointsToAdd;
    }

    private _setViewWaypointsEx = (entries: Array<any>, routeID: number, entityType: GeomapEntityType, update: boolean = true, zoom?: boolean, clickCallback?: (...args: any[]) => void) => {
        let waypointsToAdd: Array<WaypointData> = [];
        if (entries != null) {
            entries.forEach((e) => {
                let waypoint = this._setWaypoint(this._util.mapToWaypoint(e, entityType, this.state.isLiveLocation),
                    zoom == null ? entries.length === 1 : zoom, routeID, clickCallback);
                if (waypoint)
                    waypointsToAdd.push(waypoint);
            });
            if (update) {
                this._addToTmpAndSetState(waypointsToAdd, routeID);
            }
        } else {
            NotificationHelper.showErrorMessage(this.state.translations["GeoMap.AddressNotFound"]);
        }
        return waypointsToAdd;
    }

    private _setViewWaypointByWaypoint = (waypoint: WaypointData, routeID: number) => {
        this.clearRoute(routeID, () => {
            if (waypoint) {
                this._setWaypoint(waypoint, false, routeID);
                this._addToTmpAndSetState([waypoint], routeID);
            }
        });
    }

    private _setWaypoint = (waypoint: WaypointData, zoom: boolean = false, routeId: number = null, clickCallback?: (...args: any[]) => void) => {
        if (waypoint) {
            if (waypoint.lat != null && waypoint.lng != null
                && (waypoint.lat !== 0 || waypoint.lng !== 0)) {
                this._setMarker(waypoint, zoom, routeId, clickCallback);
            }
            else {
                const addr = (Helper.hasValue(waypoint.address) && waypoint.address.trim() != '') ? " - " + waypoint.address : "";
                if (waypoint.waypointType == WaypointType.ASSIGNMENT && Helper.hasValue(waypoint.entityId.projnr) && Helper.hasValue(waypoint.entityId.pindex)) {
                    NotificationHelper.showErrorMessage(waypoint.entityId.projnr + '/' + waypoint.entityId.pindex
                        + addr + " - " + this.state.translations["GeoMap.AssignmentAddressNotGeocoded"]);
                }
                else
                    NotificationHelper.showErrorMessage(this.state.translations["GeoMap.AddressNotFound"] + addr);
                return;
            }
            return waypoint;
        }
        else {
            NotificationHelper.showErrorMessage(this.state.translations["GeoMap.AddressNotFound"]);
        }
    }

    private _setMarker = (waypoint: WaypointData, zoom: boolean, routeId: number, clickCallback?: (...args: any[]) => void) => {
        try {
            this.resetToggleState.set(routeId, true);
            this.cartographer.setMarkerByType(waypoint, routeId, clickCallback);
            if (zoom) {
                this.cartographer.setZoom(12);
                this.cartographer.panTo(waypoint.lat, waypoint.lng);
            }
        } catch (ex) {
            NotificationHelper.showErrorMessage(ex.message);
            console.error(ex.message);
        }
    }

    private _reorderWaypoints = (waypoints: Array<WaypointData>, reorderedPoints?: Array<number>) => {
        let geocodedWaypoints = this._util.getGeocodedWaypoints(waypoints);
        let reorderedWaypoints: Array<WaypointData> = new Array<WaypointData>(geocodedWaypoints.length);

        for (let i = 0; i < geocodedWaypoints.length; i++) {
            if (i !== 0 && i !== (geocodedWaypoints.length - 1)) {
                reorderedWaypoints[i] = geocodedWaypoints[reorderedPoints[i - 1] + 1];
            }
            else {
                reorderedWaypoints[i] = geocodedWaypoints[i];
            }
        };

        return reorderedWaypoints.concat(this._util.getWaypointsWithoutGeocode(waypoints));
    }

    private _handleDirectionsResultAndSetState = (result: google.maps.DirectionsResult, routeID: number) => {
        let routesTmp = this._util.deepCopyArray(this.state.routes);
        this._useDirectionsResultForRoutes(routesTmp, result, routeID);
        this.setState({ routes: routesTmp });
    }

    private _useDirectionsResultForRoutes = (routes: Array<RouteObject>, result: google.maps.DirectionsResult, routeID: number) => {
        let route: RouteObject = this._innoHelper.getArrayItem(routes, "id", routeID);
        let routingLayer = this.cartographer.createRoutingLayer(result, route.id);
        let total = this._geomapService.getTotalDistanceAndTime(result);
        route.time = total.duration;
        route.distance = total.distance;
        route.color = routingLayer.get("color");
        route.layerSet = true;
        route.routePath = result.routes[0].overview_path;
        route.legs = result.routes[0].legs;
        let waypoints = route.waypoints;

        this.cartographer.addNumbersToMarkers(
            this._util.getGeocodedWaypoints(waypoints),
            result.routes[0].waypoint_order ? result.routes[0].waypoint_order : null);

        if (this.props.sortAfterOptimisation && result.routes[0].waypoint_order) {
            route.waypoints = this._reorderWaypoints(waypoints, result.routes[0].waypoint_order);
        }
    }

    private _openWindow = (searchTitle: string, url: string, successFunction: Function, routeID: number, entityType?: GeomapEntityType) => {
        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, { disableTabTitle: true });
        sheet.setTitle(searchTitle);
        sheet.bind(SheetEventType.ItemsSelected, (e) => {
            if (Array.isArray(e.data) && e.data.length > 0) {
                this._getByType(e.data, entityType).then((resultObjects) => {
                    successFunction(resultObjects, routeID, entityType);
                }, (error) => {
                    console.error(error);
                });
            }
        });
    }

    private _getNewID = (routes: Array<RouteObject>) => {
        let highestID = 0;
        routes.map(function (route) {
            if (route.id > highestID)
                highestID = route.id;
        });

        return highestID + 1;
    }

    private _shiftWaypoint = (idx: number, oldRouteId: number, newRouteId: number, newIdx: number) => {
        let routesTmp = this._util.deepCopyArray(this.state.routes);
        let waypoint = this._innoHelper.getArrayItem(routesTmp, "id", oldRouteId).waypoints.splice(idx, 1) as Array<WaypointData>;
        this.cartographer.removeNumbersFromMarkers(waypoint);
        if (newIdx != null) {
            this._innoHelper.getArrayItem(routesTmp, "id", newRouteId).waypoints.splice(newIdx, 0, waypoint[0]);
        }
        else {
            this._innoHelper.getArrayItem(routesTmp, "id", newRouteId).waypoints.push(waypoint[0]);
        }
        if (oldRouteId !== newRouteId) {
            this.cartographer.removeMarker(waypoint[0].markerId);
            this._setMarker(waypoint[0], false, newRouteId);
        }
        this.setState({ routes: routesTmp }, () => {
            if (oldRouteId !== newRouteId) {
                this.clearRoute(oldRouteId, () => { this.clearRoute(newRouteId) });
            }
            else {
                this.clearRoute(newRouteId);
            }
        });
    }

    private _scroll = (step: number) => {
        let scrollY = $(this._directionsDiv).scrollTop();
        $(this._directionsDiv).scrollTop(scrollY + step);
        if (!this._stopScrolling) {
            setTimeout(() => { this._scroll(step) }, 20);
        }
    }

    private _setDataItemsFromPerimeterSearch = (dataItems: any, entityType: GeomapEntityType, routeID: number, update: boolean = true) => {
        if (Array.isArray(dataItems))
            return this._setViewWaypoints(dataItems, routeID, entityType, update, false);
        else if (dataItems) {
            let wa = [dataItems];
            return this._setViewWaypoints(wa, routeID, entityType, update, false);
        }
    }

    private _addPointToRoute = (point: PointInfo, routeId: number) => {
        let adrnr = "";
        if (point.entityType === PointType.Ticket) {
            adrnr = point.entity.Adresse_Key;
        } else if (point.entityType === PointType.Assignment) {
            adrnr = point.entity.AdrNr;
        } else if (point.entityType === PointType.Machine) {
            adrnr = point.entity.AddressData?.AdrNr != undefined ? point.entity.AddressData.AdrNr : point.entity.AdrNr;
        } else {
            adrnr = point.entity.AdrNr;
        }

        if (point.entityType === PointType.Assignment || point.entityType === PointType.Ticket ||
            (point.entityType === PointType.Machine && point.entity.UseMaschLocation === false)) {
            this._geomapService.getAddressById(adrnr).then((result: JsonResultClass) => {
                if (result.Code !== 1) {
                    point.entity.laengegrad = result.Data.Laengegrad;
                    point.entity.breitegrad = result.Data.Breitegrad;
                    point.entity.strasse = result.Data.Strasse;
                    point.entity.ort = result.Data.Ort;
                    point.entity.plz = result.Data.Plz;
                    if (point.entity.adrname === undefined)
                        point.entity.adrname = result.Data.AdrName;
                    if (point.entity.adrnr === undefined)
                        point.entity.adrnr = result.Data.AdrNr;
                    this._setViewWaypoints([point.entity], routeId, this._util.mapToGeomapEntityType(point.entityType), true, true);
                }
                else {
                    NotificationHelper.showErrorMessage(this.state.translations["GeoMap.AddPointFailure"]);
                }
            });
        }
        else {
            this._setViewWaypoints([point.entity], routeId, this._util.mapToGeomapEntityType(point.entityType), true, true);
        }
    }

    private _registerRoutes = () => {
        this._srService.registerRoutes(this.state.routes.map((route) => {
            return { routeId: route.id, name: route.name };
        }))
    }



    private _addToPointsToAdd = (point: PointInfo, routeId?: number) => {
        this._pointsToAdd.push({ point: point, routeId: routeId });
    }

    private _handlePointsToAdd = () => {
        let points = [...this._pointsToAdd];
        this._pointsToAdd = [];
        points.forEach((p) => {
            this._addPointFromDiffTab(p.point, p.routeId);
        });
    }

    private _addPointFromDiffTab = (point: PointInfo, routeId?: number) => {
        if (this.state.routes.length === 0) {
            let routesTmp = this.createRouteAndGetRoutesCopy(null, false);
            let newId = routesTmp[routesTmp.length - 1].id;
            this.setState({
                routes: routesTmp
            }, () => {
                this._addPointToRoute(point, newId);
                this._registerRoutes();
            });
        }
        else {
            if (this.state.routes.length === 1 || routeId == null) {
                this._addPointToRoute(point, this.state.routes[this.state.routes.length - 1].id);
            }
            else {
                this._addPointToRoute(point, routeId);
            }
        }
    }

    private _removeWaypoint = (waypointId: string, routeID: number, callback?: () => any) => {
        const routesTmp = this._util.deepCopyArray(this.state.routes);
        const route = this._innoHelper.getArrayItem(routesTmp, "id", routeID);
        const waypoint = this._innoHelper.getArrayItem(route.waypoints, "id", waypointId);
        route.waypoints = route.waypoints.filter((waypoint) => {
            return waypoint.id !== waypointId;
        });
        this.cartographer.removeMarker(waypoint.markerId);
        this.removePointMarking();
        this.setState({ routes: routesTmp }, callback ? callback : null);
    }

    private _tryToGeocode = async (route: Array<RouteObject>) => {
        for (let i = 0; i < route.length; i++) {
            await this._tryToGeocodeWithWaypoints(route[i].waypoints, route[i].id);
        }
    }

    private _tryToGeocodeWithWaypoints = async (waypoints: Array<WaypointData>, routeId: number) => {
        for (let i = 0; i < waypoints.length; i++) {
            let waypoint = waypoints[i];
            if (waypoint.lat == null || waypoint.lng == null
                || (waypoint.lat === 0 && waypoint.lng === 0)) {
                try {
                    if ($.trim(waypoint.address)) {
                        let result = await this.cartographer.geocode(waypoint.address);
                        waypoint.lat = result[0].geometry.location.lat();
                        waypoint.lng = result[0].geometry.location.lng();
                        this._setMarker(waypoint, false, routeId);
                    }
                }
                catch (e) {
                    console.log(e);
                }
            }
        }
        return Promise.resolve();
    }

    private _createSliderField = (model: string) => {
        let field: SliderField = {
            type: "slider",
            name: "perimeterSearchSlider",
            min: 0,
            max: this.props.sliderMax ? this.props.sliderMax : 100,
            smallStep: this.props.sliderSmallStep ? this.props.sliderSmallStep : 1,
            largeStep: this.props.sliderLargeStep ? this.props.sliderLargeStep : 10,
            model: model
        };
        return field;
    }

    private _sliderChanged = (field: { model: string }, value: any, dataItem?: any) => {
        clearTimeout(this._sliderTimeoutId);
        if (this.state.choosenLat != null && this.state.choosenLng != null) {
            this.cartographer.setCircle(new google.maps.LatLng(this.state.choosenLat, this.state.choosenLng), this.props.useMiles ? value * 1000 * this._conversionFactor : value * 1000);
        }
        this.setState({ distance: value }, () => {
            this._sliderTimeoutId = window.setTimeout(this.triggerDynamicSearch, 1000);
        });
    }

    private _registerToggleHandler = () => {
        if (this._perimeterSearchApp) {
            General.Drawer.Left.onToggle(this.resizeSlider);
            General.Drawer.SideTabs.onToggle(this.resizeSlider);
        }
    }

    private _buildUrl = (routeID: number) => {
        const waypoints = this._innoHelper.getArrayItem(this.state.routes, "id", routeID).waypoints;
        let addressUrlPart = "";
        const arrayLength = waypoints.length;
        if (arrayLength > 0) {
            waypoints.forEach((w, i) => {
                if (i === 0) {
                    if (arrayLength === 1) {
                        addressUrlPart += "https://www.google.com/maps/search/?api=1&";
                        addressUrlPart += `query=${w.lat},${w.lng}`;
                    }
                    else {
                        addressUrlPart += "https://www.google.com/maps/dir/?api=1&";
                        addressUrlPart += `origin=${w.lat},${w.lng}`;
                        if (arrayLength > 2) {
                            addressUrlPart += `&waypoints=`;
                        }
                    }
                }
                else {
                    if (i < arrayLength - 1) {
                        addressUrlPart += `${w.lat},${w.lng}`;
                        if (i < arrayLength - 2) {
                            addressUrlPart += "|";
                        }
                    }
                    else {
                        addressUrlPart += `&destination=${w.lat},${w.lng}`;
                    }
                }
            });
        }

        return encodeURI(addressUrlPart);
    }

    private _createGMUrl = (routeID: number) => {
        const linkUrl = this._buildUrl(routeID);
        this.setState({ googleMapsLinkUrl: linkUrl }, this._googleMapsDialogRef.open);
    }

    private _copyToClipboard = () => {
        const textBoxDiv = ReactDOM.findDOMNode(this._textBoxRef) as HTMLInputElement;
        textBoxDiv.select();
        document.execCommand('copy');
    }

    private _setGoogleMapsUrlDialogRef = (r: Dialog) => {
        this._googleMapsDialogRef = r;
    }

    private _setTextBoxRef = (r: TextBox) => {
        this._textBoxRef = r;
    }

    private _setDialogProps = (translations: Object) => {
        this._googleMapsUrlDialogActions = [
            {
                label: Config.translations.close,
                action: () => {
                }
            },

            {
                label: translations["GeoMap.OpenInNewBrowserTab"],
                action: () => {
                    this._innoHelper.openInNewBrowserTab(this.state.googleMapsLinkUrl);
                    return false;
                }
            },
            {
                label: translations["GeoMap.CopyToClipboard"],
                action: () => {
                    this._copyToClipboard();
                    return false;
                },
                primary: true
            }
        ];

        this._googleMapsUrlDialogProps = {
            title: translations["GeoMap.CreateGoogleMapsUrl"],
            actions: this._googleMapsUrlDialogActions,
            afterClose: () => {
            },
            width: 800,
            open: false
        };

        this._timeSpanFilterDialogActions = [
            {
                label: Config.translations.close,
                action: () => {
                }
            },
            {
                label: Config.translations.filter,
                action: () => {
                    return this.filterResources();
                },
                primary: true
            }];

        this._timeSpanFilterDialogProps = {
            title: translations["GeoMap.AssignmentFilter"],
            actions: this._timeSpanFilterDialogActions,
            afterClose: () => {
                //Performance
                setTimeout(() => { this.setState({ timeSpanFilterOpen: false }); }, 0);
            },
            width: 500,
            open: false
        };

        this._containerViewDialogActions = [
            {
                label: Config.translations.close,
                action: () => {
                }
            },
            {
                label: Config.translations.add,
                action: () => {
                    return this.containerViewTimestampSet();
                },
                primary: true
            }];

        this._containerViewDialogProps = {
            title: translations["Einsatz.Container"],
            actions: this._containerViewDialogActions,
            afterClose: () => {
                //Performance
                setTimeout(() => { this.setState({ containerViewDialogOpen: false }); }, 0);
            },
            width: 500,
            open: false
        };

        this._activeResourceAssignmentsViewDialogActions = [
            {
                label: Config.translations.close,
                action: () => {
                }
            },
            {
                label: Config.translations.add,
                action: () => {
                    return this.activeResourceAssignmentsViewSet();
                },
                primary: true
            }];

        this._activeResourceAssignmentsViewDialogProps = {
            title: translations["GeoMap.ActiveResourceAssignments"],
            actions: this._activeResourceAssignmentsViewDialogActions,
            afterClose: () => {
                //Performance
                setTimeout(() => { this.setState({ activeResourceAssignmentsViewDialogOpen: false }); }, 0);
            },
            width: 500,
            open: false
        };
    }

    private _setMarkerByCoordinates = (coordinates: google.maps.LatLng, routeID: number) => {
        this.clearRoute(routeID, () => {
            let waypoint = { id: kendo.guid(), lat: coordinates.lat(), lng: coordinates.lng(), description: this.state.translations["GeoMap.FreePlannedPoint"], waypointType: WaypointType.COORDINATEPIN } as WaypointData;
            if (waypoint) {
                this._setWaypoint(waypoint, false, routeID);
                this._addToTmpAndSetState([waypoint], routeID);
            }
        });
    }

    private _setContextMenuRef = (ref: HTMLDivElement) => {
        this._contextMenuRef = ref;
    }

    private _addContextMenuHoveredClass = () => {
        this._contextMenuRef.style.left = this.state.currentContextMenuPos.x.toString() + "px";
        this._contextMenuRef.style.top = this.state.currentContextMenuPos.y.toString() + "px";
        this._contextMenuRef.classList.add("geomap__context-menu--hovered");
    }

    private _drawRoutesForEachRouteContainer = (idsToOmit?: Array<number>) => {
        let routesTmp = this._util.deepCopyArray(this.state.routes);
        let promises: Array<Promise<unknown>> = [];
        routesTmp.forEach((route) => {
            if (idsToOmit == null || idsToOmit.indexOf(route.id) === -1) {
                let waypoints = this._util.getGeocodedWaypoints(this._innoHelper.getArrayItem(this.state.routes, "id", route.id).waypoints);
                if (waypoints.length >= 2) {
                    let promise = this.cartographer.drawRoute(waypoints).then((result) => {
                        this._useDirectionsResultForRoutes(routesTmp, result, route.id);
                    }, (status: google.maps.GeocoderStatus) => {
                        console.log(status.toString());
                        NotificationHelper.showErrorMessage(this.state.translations["GeoMap.RouteNotFound"]);
                    });
                    promises.push(promise);
                }
            }
        });
        Promise.all(promises).then(() => {
            this.setState({ routes: routesTmp }, () => {
                this._util.onNextFrame(() => {
                    this.cartographer.setFocusToAllMarkers();
                    this.sendRouteColors();
                });
            });
        });
    }

    private _getAddressInfo = (adrnr: string): Promise<boolean> => {
        this.adrnrEntity = null;
        return new Promise<boolean>(async (resolve) => {
            const result = await HTTPService.get<JsonResultClass>("Address/Get", { id: adrnr })
            if (Helper.hasValue(result) && result.Code === 0) {
                this.adrnrEntity = result.Data;
                resolve(true);
            } else
                resolve(false);

        });
    }

    private _reloadResources = () => {
        let routesTmp = this._util.deepCopyArray(this.state.routes);
        let routeWithPoints = new Map<number, Array<WaypointData>>();

        routesTmp.forEach((route) => {
            const pointsToChange = route.waypoints.filter((waypoint) => {
                return waypoint.waypointType === WaypointType.RESOURCE;
            });
            routeWithPoints.set(route.id, pointsToChange);
        });
        let ressNrs: Array<string> = [];
        routeWithPoints.forEach((pointsToChange) => {
            ressNrs = ressNrs.concat(pointsToChange.map((resource) => {
                return resource.entityId;
            }));
        });

        //Unique values
        ressNrs = ressNrs.filter((ressNr, idx, self) => {
            return self.indexOf(ressNr) === idx;
        });

        if (ressNrs.length > 0) {
            this._geomapService.getResourcesByIds(ressNrs).then((result: JsonResultClass) => {
                if (result.Code === 0) {
                    routeWithPoints.forEach((points, routeId) => {
                        points.forEach(async (point) => {
                            const resources = result.Data as Array<any>;
                            const entity = Helper.getArrayItem(resources, "Ressnr", point.entityId);
                            this.cartographer.removeMarker(point.markerId);
                            const route = this._innoHelper.getArrayItem(routesTmp, "id", routeId);
                            const idx = route.waypoints.findIndex((waypoint) => {
                                return waypoint.id === point.id;
                            });
                            var newWaypoint = this._util.mapToWaypoint(entity, WaypointType.RESOURCE.valueOf(), this.state.isLiveLocation);

                            /*if (newWaypoint.address.trim() == "" || (newWaypoint.lat == null && newWaypoint.lng == null)) {
                                if (entity.Adrnr != null && await this._getAddressInfo(entity.Adrnr))
                                    newWaypoint = this._util.mapToWaypoint(this.adrnrEntity, WaypointType.ADDRESS.valueOf(), this.state.isLiveLocation);
                            }*/

                            route.waypoints.splice(idx, 1, newWaypoint);
                            this.cartographer.setMarkerByType(newWaypoint, routeId);
                        });
                    });
                    this.setState({ routes: routesTmp });
                }
                else {
                    console.error(result.Message);
                }
            }, (error) => {
                console.error(error);
            });
        }
    }

    private _getByType = (entities: Array<any>, entityType: GeomapEntityType) => {
        return new Promise<Array<any>>((resolve, reject) => {
            //ToDo: implement other types
            if (entityType === GeomapEntityType.ResourceViewEntity) {
                const ressNrs = entities.map((resource) => {
                    return resource.ressnr as string;
                });
                this._geomapService.getResourcesByIds(ressNrs).then((result: JsonResultClass) => {
                    if (result.Code === 0) {
                        resolve(result.Data);
                    }
                    else {
                        reject(result.Message);
                    }
                });
            }
            else {
                resolve(entities);
            }
        });
    }

    private _clearRouteProperties = (route: RouteObject) => {
        route.time = null;
        route.distance = null;
        route.color = null;
        let waypoints = route.waypoints;
        this.cartographer.removeNumbersFromMarkers(this._util.getGeocodedWaypoints(waypoints));
        this.cartographer.removeRoutingLayer(route.id);
        route.layerSet = false;
        route.routePath = null;
        this.removeRouteMarking();
    }

    //JSX
    private _renderRightDrawerComponent = () => {
        if (this._rightDrawerContainer !== null) {
            let entity: Entity = {
                IsNew: true,
                RecordRight: {
                    CanRead: true, CanWrite: true
                },
                IsWatchable: false,
                IsWatched: false
            };

            return <RightDrawerContainer
                moduleName={this._rightDrawerContainer.moduleName}
                appName={this._rightDrawerContainer.appName}
                visible={this._rightDrawerContainer.visible}
                width={this._rightDrawerContainer.width}
                customProps={this._rightDrawerContainer.props}
                entity={entity}
                renderAlways={this._rightDrawerContainer.renderAlways}
                multipleComponents={this._rightDrawerContainer.multipleComponents}
            />
        }

        return null;
    }

    private _getPinElements = () => {

        return (<div style={{ display: "none" }}>
            <div id="outerDivOfPinElements">
                <div id="addressPinElement">
                    <span className="fa-layers fa-fw">
                        <i className="fa fa-map-marker"></i>
                        <i className="fal fa-home"></i>
                    </span>
                </div>
                <div id="machinePinElement">
                    <span className="fa-layers fa-fw">
                        <i className="fa fa-map-marker"></i>
                        <i className="fal fa-cogs"></i>
                    </span>
                </div>
                <div id="resourcePinElement">
                    <span className="fa-layers fa-fw">
                        <i className="fa fa-map-marker"></i>
                        <i className="fal fa-child"></i>
                    </span>
                </div>
                <div id="resourceTmpPinElement">
                    <span className="fa-layers fa-fw">
                        <i className="fa fa-map-marker"></i>
                        <i className="fal fa-car"></i>
                    </span>
                </div>
                <div id="assignmentPinElement">
                    <span className="fa-layers fa-fw">
                        <i className="fa fa-map-marker"></i>
                        <i className="fal fa-calendar-check"></i>
                    </span>
                </div>
                <div id="ticketPinElement">
                    <span className="fa-layers fa-fw">
                        <i className="fa fa-map-marker"></i>
                        <i className="fal fa-exclamation-circle"></i>
                    </span>
                </div>
            </div>
            <div id="clusterMarkerElement">
                <i className="fa fa-map-marker"></i>
            </div>
        </div>)
    }

    private _buildMapContextMenu = () => {
        let divArr = [];
        this.state.routes.forEach((route) => {
            divArr.push(<div key={route.id} onClick={() => { this._setMarkerByCoordinates(this.state.currentLatLngOfMarkerToAdd, route.id); }}>{route.name}</div>);
        });
        return <div ref={this._setContextMenuRef} className="geomap__context-menu">{divArr}</div>;
    }

    private _getRouteComponents = (routes: Array<RouteObject>) => {
        return routes.map((route: RouteObject, i) => {
            const resetToggle = this.resetToggleState.get(route.id) || false;
            return <Route key={route.id} routeIndex={i} route={route}
                openAddressSearch={this.openAddressSearch} openMachineSearch={this.openMachineSearch} openTicketSearch={this.openTicketSearch}
                openResourceSearch={this.openResourceSearch} openAssignmentSearch={this.openAssignmentSearch}
                draw={this.drawRoute} optimize={this.optimize} clearRoute={this.clearRoute} translations={this.state.translations}
                deleteRoute={this.deleteRoute} targetOnDrop={this.targetOnDrop} togglePins={this.togglePins} resetToggleState={resetToggle}
                setFocusToPins={this.setFocusToPins} useMiles={this.props.useMiles} openGoogleMapsUrlDialog={this.openGoogleMapsUrlDialog}
                openPerimeterSearch={this.openPerimeterSearchFromRoute} searchAlongRouteAvailable={this.props.searchAlongRouteAvailable}
                copyContainer={this.copyContainer} markRoute={this.markRoute} removeRouteMarking={this.removeRouteMarking}>
                {route.waypoints.length <= (this.props.maxContainerSize || 25) ?
                    this._getWaypointsForRoute(route.waypoints, route.id) :
                    <div className="geomap__elements-div" onClick={() => { this.deleteWaypointsFromRoute(route.id) }}>{`${route.waypoints.length} ${this.state.translations["GeoMap.ElementsSelected"]} ${this.state.translations["GeoMap.ClickToRemove"]}`}</div>}
            </Route>
        });
    }

    private _getWaypointsForRoute = (waypoints: Array<WaypointData>, routeId: number) => {
        return waypoints.map((waypoint: WaypointData, i) => {
            return <Waypoint key={waypoint.id} idx={i} routeID={routeId}
                waypoint={waypoint} setFocusToMarker={this.setFocusToMarker} removeWaypoint={this.removeWaypoint} translations={this.state.translations}
                openPerimeterSearch={this.openPerimeterSearch} onDragEnd={this.onDragEnd} onDrag={this.onDrag} targetOnDrop={this.targetOnDrop}
                markPoint={this.markPoint} removePointMarking={this.removePointMarking}>
            </Waypoint>
        });
    }

    resizeSlider = () => {
        kendo.resize(ReactDOM.findDOMNode(this._sliderRef) as Element, true);
    }

    addPoint = (point: PointInfo, routeId?: number) => {
        if (this._svgsPrepared) {
            this._addPointFromDiffTab(point, routeId);
        }
        else {
            this._addToPointsToAdd(point, routeId);
        }
    }

    handleMapCreated = (lat: number, lng: number, cartographer: Cartographer, mapGuid: string) => {
        this.cartographer = cartographer;
        this.cartographer.setClusterSizes(this.props.minimumClusterSize, this.props.clusterGridSize);

        document.addEventListener("contextmenu", this.preventOpeningOfContextMenu);

        this._svgsPrepared = true;
        let waypointsToAdd: Array<any> = [];
        if (this.props.type) {
            this._initRoutes(this.props.type, this.props.id1, this.props.id2, this.props.resourceIDs, this.props.groups).then((result: Array<WaypointData> | DirectionsAppState) => {
                //AssignmentAddresses
                if (Array.isArray(result)) {
                    for (let i = 0; i < result.length; i++) {
                        if (result[i])
                            waypointsToAdd.push(result[i]);
                    }
                    this._addToTmpAndSetState(waypointsToAdd, 1, () => {
                        this._registerRoutes();
                        this._handlePointsToAdd();
                        window.dispatchEvent(new Event("GeomapLoaded"));
                    });
                }
                //ResourceRoutes
                else {
                    if (this._util.isDirectionsAppState(result)) {
                        this.setState(result, () => {
                            this._registerRoutes();
                            //Keine Route für den Container/Arbeitsvorrat
                            this._drawRoutesForEachRouteContainer([1]);
                            window.dispatchEvent(new Event("GeomapLoaded"));
                        });
                    }
                }
            });
        }
        else {
            if (this.props.pointInfo != null) {
                this._addToPointsToAdd(this.props.pointInfo, null);
            }
            this._handlePointsToAdd();
            window.dispatchEvent(new Event("GeomapLoaded"));
        }
    }

    removeWaypoint = (waypointId: string, routeID: number, callback?: () => any) => {
        let routesTmp = this._util.deepCopyArray(this.state.routes);
        let route = this._innoHelper.getArrayItem(routesTmp, "id", routeID)
        let waypoint = this._innoHelper.getArrayItem(route.waypoints, "id", waypointId);
        if (waypoint != null) {
            if (waypoint.lat || waypoint.lng) {
                this.clearRoute(routeID, () => {
                    this._removeWaypoint(waypointId, routeID, callback);
                });
            }
            else {
                this._removeWaypoint(waypointId, routeID, callback);
            }
        }
    }

    drawRoute = (routeID: number) => {
        let waypoints = this._util.getGeocodedWaypoints(this._innoHelper.getArrayItem(this.state.routes, "id", routeID).waypoints);
        if (waypoints.length >= 2) {
            this.cartographer.drawRoute(waypoints).then((result) => {
                this._handleDirectionsResultAndSetState(result, routeID);
            }, (status: google.maps.GeocoderStatus) => {
                console.log(status.toString());
                NotificationHelper.showErrorMessage(this.state.translations["GeoMap.RouteNotFound"]);
            });
        }
    }

    optimize = (routeID: number) => {
        let waypoints = this._util.getGeocodedWaypoints(this._innoHelper.getArrayItem(this.state.routes, "id", routeID).waypoints);
        if (waypoints.length >= 2) {
            this.cartographer.optimize(waypoints).then((result) => {
                this._handleDirectionsResultAndSetState(result, routeID);
            }, (status: google.maps.GeocoderStatus) => {
                console.log(status.toString());
                NotificationHelper.showErrorMessage(this.state.translations["GeoMap.RouteNotFound"]);
            });
        }
    }

    clearRoute = (routeID: number, callback?: () => any) => {
        let routesTmp = this._util.deepCopyArray(this.state.routes);
        let route = this._innoHelper.getArrayItem(routesTmp, "id", routeID) as RouteObject;
        if (route && route.layerSet) {
            this._clearRouteProperties(route);
            this.setState({ routes: routesTmp }, callback ? callback : null);
        }
        else {
            if (callback) {
                callback();
            }
        }
    }

    clearRoutes = (routeIDs: Array<number>) => {
        let routesTmp = this._util.deepCopyArray(this.state.routes);
        routeIDs.forEach((routeID) => {
            let route = this._innoHelper.getArrayItem(routesTmp, "id", routeID) as RouteObject;
            if (route && route.layerSet) {
                this._clearRouteProperties(route);
            }
        });
        return routesTmp;
    }

    setFocusToMarker = (idx: number, routeID: number) => {
        this.cartographer.setFocusToMarker(this._innoHelper.getArrayItem(this.state.routes, "id", routeID).waypoints[idx].lat, this._innoHelper.getArrayItem(this.state.routes, "id", routeID).waypoints[idx].lng);
    }

    openAddressSearch = (routeID: number) => {
        this._openWindow(this.state.translations["Adresse.Adresssuche"], "DynamicSearch/Window/Address?multi=true&displayPattern=[[adrname]]", this._setViewWaypoints, routeID, GeomapEntityType.AddressViewEntity);
    }

    openMachineSearch = (routeID: number) => {
        this._openWindow(this.state.translations["Maschine.Maschinensuche"], "DynamicSearch/Window/Machine?multi=true&displayPattern=[[maschbezeichnung]]", this._setViewWaypoints, routeID, GeomapEntityType.MachineViewEntity);
    }

    openResourceSearch = (routeID: number) => {
        this._openWindow(this.state.translations["Ressource.Ressourcensuche"], "DynamicSearch/Window/Resource?withSkills=true&multi=true&displayPattern=[[name]]", this._setViewWaypoints, routeID, GeomapEntityType.ResourceViewEntity);
    }

    openAssignmentSearch = (routeID: number) => {
        this._openWindow(this.state.translations["WebSMS.Assignment.AssignmentSearch"], "DynamicSearch/Window/Assignment?multi=true&displayPattern=[[adrname]]", this._setViewWaypoints, routeID, GeomapEntityType.AssignmentViewEntity);
    }

    openTicketSearch = (routeID: number) => {
        this._openWindow(this.state.translations["Vorgang.Ticketsuche"], "DynamicSearch/Window/Procedure?multi=true&displayPattern=[[problemnr]]", this._setViewWaypoints, routeID, GeomapEntityType.TicketViewEntity);
    }

    createRouteAndGetRoutesCopy = (e?: React.MouseEvent<HTMLDivElement>, setState: boolean = true) => {
        let routesTmp = this._util.deepCopyArray(this.state.routes);
        let newId = this._getNewID(routesTmp);
        routesTmp.push({ id: newId, waypoints: [], name: this.state.translations["GeoMap.Container"] + " " + newId } as RouteObject);
        if (setState) {
            this.setState({
                routes: routesTmp
            }, () => {
                this._registerRoutes();
            });
        }
        return routesTmp;
    }

    newContainerView = () => {
        this.setState({ containerViewDialogOpen: true });
    }

    newActiveResourceAssignmentsView = () => {
        this.setState({ activeResourceAssignmentsViewDialogOpen: true });
    }

    containerViewTimestampSet = () => {
        let d1 = this.state.containerViewTimeSpanStart;
        let d2 = this.state.containerViewTimeSpanEnd;

        const canDo = this._innoHelper.hasValue(d1) &&
            this._innoHelper.hasValue(d2) &&
            this._innoHelper.dates.dateDiffInDays(d1, d2) > 0;

        if (canDo) {
            d1 = this._innoHelper.dates.toDate(d1);
            d2 = this._innoHelper.dates.toDate(d2);

            this._geomapService.getContainerAssignments(d1, d2).then((result: JsonResultClass) => {
                if (result.Code === 0) {
                    const routeName = `${this.state.translations["Einsatz.Container"]} ${d1.toLocaleDateString()} - ${d2.toLocaleDateString()}`;
                    this.addAssignmentContainer(result.Data, routeName);
                }
                else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
        }
        else {
            DialogHelper.alert(this.state.translations["WebSMS.Messages.PleaseEnterValidDateTimes"]);
            return false;
        }
    }

    activeResourceAssignmentsViewSet = () => {
        if (this._innoHelper.hasValue(this.state.activeResourceAssignmentsViewTimestamp)) {
            this.setActiveResourceView(this.state.activeResourceAssignmentsViewTimestamp);
        }
        else {
            DialogHelper.alert(this.state.translations["WebSMS.Messages.PleaseEnterValidDateTimes"]);
            return false;
        }
    }

    //Aufruf auch über signalR
    setActiveResourceView = (start: Date | string, end?: Date | string) => {
        if (typeof start === "string") {
            start = kendo.parseDate(start);
        }
        if (typeof end === "string") {
            end = kendo.parseDate(end);
        }
        this._geomapService.getActiveResourceAssignments(start, end).then((result: JsonResultClass) => {
            if (result.Code === 0) {
                const startDateString = (start as Date).toLocaleDateString();
                let timePart = startDateString;
                if (end != null) {
                    const endDateString = (end as Date).toLocaleDateString();
                    if (startDateString !== endDateString) {
                        timePart = `${timePart} - ${endDateString}`;
                    }
                }
                const routeName = `${this.state.translations["GeoMap.ActiveResourceAssignments"]} ${timePart}`;
                this.addAssignmentContainer(result.Data, routeName);
            }
            else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        });
    }

    deleteRoute = (e: React.MouseEvent<HTMLDivElement>, routeID: number) => {
        e.stopPropagation();
        this.cartographer.removeRoutingLayer(routeID);
        let routesTmp = this._util.deepCopyArray(this.state.routes);
        this.cartographer.removeMarkersFromRoute(routeID);
        routesTmp.splice(this._innoHelper.findObjIndex(routesTmp, "id", routeID), 1);
        this.removeRouteMarking();
        this.setState({ routes: routesTmp }, () => {
            this._registerRoutes();
        });
    }

    togglePins = (routeID: number) => {
        this.resetToggleState.set(routeID, false);
        this.cartographer.togglePins(routeID);
        this.setState({});
    }

    openResourceFilter = () => {
        this.setState({ timeSpanFilterOpen: true });
    }

    filterResources = () => {
        if (this._innoHelper.hasValue(this.state.resourceFilterTimeSpanStart) && this._innoHelper.hasValue(this.state.resourceFilterTimeSpanEnd)
            && this.state.resourceFilterTimeSpanStart <= this.state.resourceFilterTimeSpanEnd) {
            this.cartographer.removeAllMarkers();
            this.cartographer.removeAllRoutingLayers();
            this._initResourceRoutes(this.props.resourceIDs, this.state.resourceFilterTimeSpanStart, this.state.resourceFilterTimeSpanEnd, this.props.groups).then((result) => {
                this.setState(result, () => {
                    this._registerRoutes();
                    //Keine Route für den Container/Arbeitsvorrat
                    this._drawRoutesForEachRouteContainer([1]);
                });
            });
        }
        else {
            NotificationHelper.showErrorMessage(this.state.translations["WebSMS.Messages.PleaseEnterValidDateTimes"]);
            return false;
        }
    }

    dateTimeChanged = (field: DateTimePickerField, value: any) => {
        switch (field.model) {
            case DirectionsDialogModelType.ResourceFilterStart: this.setState({ resourceFilterTimeSpanStart: value }); break;
            case DirectionsDialogModelType.ResourceFilterEnd: this.setState({ resourceFilterTimeSpanEnd: value }); break;
            case DirectionsDialogModelType.ContainerViewStart: this.setState({ containerViewTimeSpanStart: value }); break;
            case DirectionsDialogModelType.ContainerViewEnd: this.setState({ containerViewTimeSpanEnd: value }); break;
            case DirectionsDialogModelType.ActiveResourceAssignmentsViewTimestamp: this.setState({ activeResourceAssignmentsViewTimestamp: value }); break;
        }
    }

    openPerimeterSearchFromRoute = (routeID: number, searchType: WaypointType) => {
        let mappedPath = this._innoHelper.getArrayItem(this.state.routes, "id", routeID).routePath.map((p) => { return p.toJSON() });
        this.openPerimeterSearch(null, null, routeID, null, searchType, mappedPath);
    }

    openPerimeterSearch = (latitude: number, longitude: number, routeID: number, waypoint: WaypointData, searchType: WaypointType, points?: Array<google.maps.LatLngLiteral>) => {
        if (this._perimeterSearchApp != null) {
            this.closePerimeterSearch();
        }
        let distanceToUse = this.state.distance * 1000;
        let searchName = searchType === WaypointType.TICKET ? "Procedure" : WaypointType[searchType];
        let displayPattern = this._util.getDisplayPattern(searchType);

        this._perimeterSearchSheet = General.Sheet.Manager.createSheet(null, true, { disableTabTitle: true });
        this._perimeterSearchSheet.destroyOnHide(false, this._currentSheet);

        const entityType = this._util.mapFromWaypointTypeToGeomapEntityType(searchType);
        const useLiveLocation = entityType === GeomapEntityType.ResourceViewEntity && this.state.isLiveLocation;

        Promise.all([
            HTTPService.chainBatch
                .add<JsonResultClass>(`DynamicSearch/Init/?searchType=${searchName}&isWindow=true&isMulti=true&fullObject=false`)
                .add<Metadata>(Helper.getMetaData('DynamicSearch/' + searchName))
                .promise(),
            Helper.getTranslations(["Suche.NoTemplate", "Suche.NewTemplate", "Suche.Suchvorlagen", "Suche.VorlageName",
                "Suche.AutoSearch", "Suche.VorlageNameNichtNull", "Suche.VorlageNameVergeben"])
        ]).then(result => {
            const modelData = result[0][0];

            if (modelData.Code > 0) {
                NotificationHelper.showErrorMessage(modelData.Message);
            } else {
                let params: StringKeyDictionary<any> = {};
                params["searchType"] = searchName;
                params["displayPattern"] = `[[${displayPattern}]]`;
                params["isMulti"] = true;
                params["fullObject"] = false;
                params["isIFrame"] = false;
                if (searchType === WaypointType.ASSIGNMENT) {
                    params["startist_start"] = this.state.perimeterTimeSpanStart;
                    params["startist_end"] = this.state.perimeterTimeSpanEnd;
                }

                let cusParams: StringKeyDictionary<any> = {};
                cusParams["cus_latitude"] = latitude;
                cusParams["cus_longitude"] = longitude;
                cusParams["cus_distance"] = this.state.distance * 1000;
                cusParams["cus_useMiles"] = this.props.useMiles;
                cusParams["cus_points"] = points;
                cusParams["cus_useLiveLocation"] = useLiveLocation;

                const props: DynamicSearchAppProps = {
                    useDefaultImages: false,
                    searchType: searchName,
                    isWindow: true,
                    title: this.state.translations["GeoMap.PerimeterSearch"],
                    metadata: result[0][1],
                    context: { contextType: "dynamicSearch" },
                    config: modelData.Data,
                    translations: result[1].Data,
                    multiSelectPattern: `[[${displayPattern}]]`,
                    queryParameters: params,
                    customParameters: cusParams,
                    newParameters: {},
                    quick: null,
                    fullObject: false,
                    isIFrame: false,
                    withSkills: false,
                    skillsTranslations: null
                };


                this._perimeterSearchSheet.bind(SheetEventType.ItemsSelected, (e) => {
                    if (Array.isArray(e.data) && e.data.length > 0) {
                        this._getByType(e.data, entityType).then((resultObjects) => {
                            this.perimeterSearchItemsSelected(resultObjects, entityType, routeID);
                        }, (error) => {
                            console.error(error);
                        });
                    }
                });

                this._perimeterSearchSheet.bind(SheetEventType.AppMounting, (app: DynamicSearchApp) => {
                    this._perimeterSearchApp = app;
                    app.options.pageSize = 1000;
                    app.options.initialFilterState = InitialSearchFilterState.AdvancedSearch;
                });

                this._perimeterSearchSheet.bind(SheetEventType.AppMounted, (app: DynamicSearchApp) => {
                    this._perimeterSearchApp.dynamicSearchCallbacks.onAdditionalData = () => {
                        let params: StringKeyDictionary<any> = {};
                        params["cus_latitude"] = latitude;
                        params["cus_longitude"] = longitude;
                        params["cus_distance"] = this.state.distance * 1000;
                        params["cus_useMiles"] = this.props.useMiles;
                        params["cus_points"] = points;
                        cusParams["cus_useLiveLocation"] = useLiveLocation;
                        return params;
                    };

                    this._perimeterSearchApp.dynamicSearchCallbacks.onCustomButtonClick = (name: string, dataItems: any) => {
                        if (name === "addToNewRoute") {
                            this._getByType(dataItems, entityType).then((resultObjects) => {
                                this.newRouteWithSelectedItems(resultObjects, entityType, routeID, waypoint);
                            }, (error) => {
                                console.error(error);
                            });
                        }
                    };

                    if (latitude != null && longitude != null) {
                        this._perimeterSearchApp.addCustomMenuButtons([{ name: "addToNewRoute", text: this.state.translations["GeoMap.AddNewRoute"], enableOnSelect: true }]);
                    }

                    this._perimeterSearchApp.dynamicSearchCallbacks.onGridDataBound = (dataItems: Array<any>) => {
                        //routeid = null: graue icons für die Umkreissuche                        
                        this._getByType(dataItems, entityType).then((resultObjects) => {
                            this.perimeterSearchItemsFiltered(resultObjects, entityType, routeID);
                        }, (error) => {
                            console.error(error);
                        });
                    }
                });

                this._perimeterSearchSheet.mountContent(DynamicSearchApp, props);

                if (latitude != null && longitude != null) {
                    this.cartographer.setCircle(new google.maps.LatLng(latitude, longitude), this.props.useMiles ? this._conversionFactor * this.state.distance * 1000 : this.state.distance * 1000);
                }
                else {
                    this.setFocusToPins(routeID);
                }
                this.setState({ choosenLat: latitude, choosenLng: longitude, isPerimeterSearchOpen: true } as DirectionsAppState);
            }
        });
    }

    perimeterSearchItemsSelected = (dataItems: any, entityType: GeomapEntityType, routeID: number) => {
        this._setDataItemsFromPerimeterSearch(dataItems, entityType, routeID);
    }

    perimeterSearchItemsFiltered = (dataItems: any, entityType: GeomapEntityType, routeID: number) => {
        this.removePerimeterSearchLayer();
        let waypoints: Array<WaypointData>;
        if (Array.isArray(dataItems)) {
            waypoints = this._setViewWaypoints(dataItems, null, entityType, false, false, (e: any, marker: google.maps.Marker) => { this.markerClickHandler(e, marker, routeID) });
        }
        else if (dataItems) {
            let wa = [dataItems];
            waypoints = this._setViewWaypoints(wa, null, entityType, false, false, (e: any, marker: google.maps.Marker) => { this.markerClickHandler(e, marker, routeID) });
        }
        if (waypoints && waypoints.length > 0) {
            this._perimeterSearchWaypoints = waypoints;
            this.setState({ perimeterSearchMarkerIDs: waypoints.map((wp) => { return wp.markerId }) });
        }
        else {
            this._perimeterSearchWaypoints = [];
        }
    }

    newRouteWithSelectedItems = (dataItems: any, entityType: GeomapEntityType, routeID: number, waypoint: WaypointData) => {
        let routesTmp = this.createRouteAndGetRoutesCopy(null, false);
        let newId = routesTmp[routesTmp.length - 1].id;
        this.setState({
            routes: routesTmp
        }, () => {
            this.removeWaypoint(waypoint.id, routeID, () => {
                let waypoints = this._setDataItemsFromPerimeterSearch(dataItems, entityType, newId, false);
                waypoints.push(waypoint);
                this._setWaypoint(waypoint, false, newId);
                this._addToTmpAndSetState(waypoints, newId);
            });
        });
    }

    removePerimeterSearchLayer = () => {
        if (this.state.perimeterSearchMarkerIDs) {
            this.cartographer.removeMarkersFromRoute(null);
            this.setState({ perimeterSearchMarkerIDs: null });
        }
    }

    onDrag = (e: any) => {
        let directionDiv = $(this._directionsDiv);
        let directionsPos = directionDiv.position();
        this._stopScrolling = true;
        if (directionsPos.top + directionDiv.height() < e.y.location) {
            this._stopScrolling = false;
            this._scroll(1);
        }
        if (directionsPos.top > e.y.location - $(e.currentTarget).height()) {
            this._stopScrolling = false;
            this._scroll(-1);
        }
    }

    onDragEnd = (e: any, idx: number, routeID: number) => {
        if (this._currentDropTargetId != null) {
            this._shiftWaypoint(idx, routeID, this._currentDropTargetId, this._currentDropTargetIdx);
            this._currentDropTargetId = null;
            this._currentDropTargetIdx = null;
        }
        this._stopScrolling = true;
    }

    targetOnDrop = (e: any, routeID: number, dropIdx: number) => {
        this._currentDropTargetId = routeID;
        this._currentDropTargetIdx = dropIdx;
    }

    setStandardRoute = async (result: ResourceRouteContainer, drawRoute?: boolean) => {
        let resourceWaypointFrom: Array<WaypointData> = null;
        let routesTmp = this._util.deepCopyArray(this.state.routes);
        let contextRoute = this._innoHelper.getArrayItem(routesTmp, "id", 0) as RouteObject;
        if (contextRoute == null) {
            routesTmp.push({ id: 0, waypoints: [], name: this.state.translations["GeoMap.ContextRoute"] } as RouteObject);
            contextRoute = routesTmp[0];
        } else {
            //cleanup
            let route0 = this._innoHelper.getArrayItem(routesTmp, "id", 0);
            this._clearRouteProperties(route0);
        }

        this.cartographer.removeMarkersFromRoute(0);
        this.cartographer.removeRoutingLayer(0);
        contextRoute.layerSet = false;
        contextRoute.waypoints = [];
        contextRoute.isContextRoute = true;
        contextRoute.hide = false;

        if (result.resource) {
            //check has lat/lng and Address
            var resReplacedAdrnr = false;
            if ((!Helper.hasValue(result.resource.Breitegrad) && !Helper.hasValue(result.resource.Laengegrad)) ||
                (!Helper.hasValue(result.resource.Land) && !Helper.hasValue(result.resource.Ort)
                    && !Helper.hasValue(result.resource.Plz) && !Helper.hasValue(result.resource.Strasse))) {
                if (Helper.hasValue(result.resource.Adrnr)) {

                    await this._getAddressInfo(result.resource.Adrnr);
                    var s = " " + this.adrnrEntity.AdrName2;
                    result.resource.Name = this.adrnrEntity.AdrName + s.trim();
                    result.resource.Land = this.adrnrEntity.Land;
                    result.resource.Ort = this.adrnrEntity.Ort;
                    result.resource.Plz = this.adrnrEntity.Plz;
                    result.resource.Strasse = this.adrnrEntity.Strasse;
                    resourceWaypointFrom = this._setViewWaypointsEx([result.resource], 0, GeomapEntityType.AddressViewEntity, false, false);
                    resReplacedAdrnr = true;
                }
            }

            if (!resReplacedAdrnr) {
                resourceWaypointFrom = this._setViewWaypointsEx([result.resource], 0, GeomapEntityType.ResourceViewEntity, false, false);
            }

            if (result.fromHome) {
                contextRoute.waypoints = contextRoute.waypoints.concat(resourceWaypointFrom);
            }
        }

        const assignmentWaypoints = this._setViewWaypointsEx(result.assignments, 0, GeomapEntityType.AssignmentViewEntity, false, false);
        if (assignmentWaypoints) {
            contextRoute.waypoints = contextRoute.waypoints.concat(assignmentWaypoints);
        }

        if (result.backHome && result.resource != null) {
            let resourceWaypointBack = this._setViewWaypointsEx([result.resource], 0, GeomapEntityType.ResourceViewEntity, false, false);
            contextRoute.waypoints = contextRoute.waypoints.concat(resourceWaypointBack);
        }

        routesTmp = routesTmp.sort((r1, r2) => {
            return (r1.id - r2.id);
        });

        this._tryToGeocode(routesTmp).then(() => {
            this.setState({ routes: routesTmp }, () => {
                this._reloadResources();

                this._registerRoutes();
                this.setFocusToPins(0);
                if (drawRoute) {
                    this.drawRoute(0);
                }
            });
        });

    }

    addAssignmentContainer = (assignments: Array<AssignmentView>, routeName: string) => {
        let routesTmp = this.createRouteAndGetRoutesCopy(null, false);
        let newRoute = routesTmp[routesTmp.length - 1] as RouteObject;
        newRoute.name = routeName;
        newRoute.waypoints = this._setViewWaypoints(assignments, newRoute.id, GeomapEntityType.AssignmentViewEntity, false, false);
        this.setState({ routes: routesTmp }, () => {
            this._registerRoutes();
        });
    }

    setFocusToPins = (routeID: number) => {
        this.cartographer.setFocusToRoute(routeID);
    }

    deleteWaypointsFromRoute = (routeID: number) => {
        let routesTmp = this._util.deepCopyArray(this.state.routes);
        this.cartographer.removeMarkersFromRoute(routeID);
        this._innoHelper.getArrayItem(routesTmp, "id", routeID).waypoints = [];
        this.setState({ routes: routesTmp });
    }

    setDirectionsDiv = (elem: HTMLDivElement) => {
        this._directionsDiv = elem;
    }

    sliderRefFunction = (ref: Slider) => {
        this._sliderRef = ref;
        this._registerToggleHandler();
    }

    openPerimeterSearchResults = () => {
        this._perimeterSearchSheet.show();
    }

    closePerimeterSearch = () => {
        if (this._perimeterSearchApp) {
            this._perimeterSearchApp = null;
        }
        this.cartographer.removeCircle();
        this.removePerimeterSearchLayer();
        General.Drawer.Left.deregisterToggle(this.resizeSlider);
        this._perimeterSearchSheet.remove();
        this._perimeterSearchWaypoints = [];
        this.setState({ isPerimeterSearchOpen: false, distance: this.props.sliderLargeStep } as DirectionsAppState);
    }

    triggerDynamicSearch = () => {
        if (this._perimeterSearchApp) {
            this._perimeterSearchApp.triggerSearch();
        }
    }

    markerClickHandler = (e: any, marker: google.maps.Marker, routeId: number) => {
        let waypoint = this._innoHelper.getArrayItem(this._perimeterSearchWaypoints, "markerId", marker.get("id")) as WaypointData;
        this._setViewWaypointByWaypoint(waypoint, routeId);
    }

    openGoogleMapsUrlDialog = (routeID: number) => {
        this._createGMUrl(routeID);
    }

    removeContextMenuClasses = () => {
        $(".geomap__context-menu--hovered").removeClass("geomap__context-menu--hovered");
    }

    mapRightClicked = (e: google.maps.MouseEvent) => {
        e.stop();
        const length = this.state.routes.length;
        if (length > 0) {
            if (length === 1) {
                this._setMarkerByCoordinates(e.latLng, this.state.routes[this.state.routes.length - 1].id);
            }
            else {
                const point = this._util.getViewPortCoordinates(e, this.cartographer.map);
                this.setState({ currentContextMenuPos: { x: point.x, y: point.y }, currentLatLngOfMarkerToAdd: e.latLng }, () => {
                    this._addContextMenuHoveredClass();
                });
            }
        }
    }

    preventOpeningOfContextMenu = (evt: Event): any => {
        if (evt.target === this._contextMenuRef) {
            evt.preventDefault();
        }
    }

    copyContainer = (routeID: number) => {
        const waypoints = this._innoHelper.getArrayItem(this.state.routes, "id", routeID).waypoints as Array<WaypointData>;
        const newRoutes = this.createRouteAndGetRoutesCopy(null, false) as Array<RouteObject>;
        const newRoute = newRoutes[newRoutes.length - 1];
        newRoute.waypoints = this.copyAndSetWaypoints(waypoints, newRoute.id);
        this.setState({ routes: newRoutes }, this._registerRoutes);
    }

    copyAndSetWaypoints = (waypoints: Array<WaypointData>, routeID: number) => {
        const waypointsCopy = this._util.deepCopyArray(waypoints);
        let newWaypoints = [];

        this.clearRoute(routeID, () => {
            waypointsCopy.forEach((waypointCopy) => {
                waypointCopy.id = kendo.guid();
                waypointCopy.markerId = null;
                let waypoint = this._setWaypoint(waypointCopy, false, routeID, null);
                if (waypoint != null) {
                    newWaypoints.push(waypoint);
                }
            });
        });

        return newWaypoints;
    }

    markRoute = (routeId: number) => {
        if (this.cartographer != null) {
            this.cartographer.markRouteByID(routeId);
        }
    }

    markRouteByRessNr = (ressNr: string) => {
        if (this.cartographer != null) {
            let route: RouteObject = this._innoHelper.getArrayItem(this.state.routes, "ressNr", ressNr);
            if (route != null) {
                this.cartographer.markRouteByID(route.id);
            }
        }
    }

    removeRouteMarking = () => {
        if (this.cartographer != null) {
            this.cartographer.removeRouteMarking();
        }
    }

    markPoint = (markerID: string) => {
        if (this.cartographer != null) {
            this.cartographer.markPoint(markerID);
        }
    }

    removePointMarking = () => {
        if (this.cartographer != null) {
            this.cartographer.removePointMarking();
        }
    }

    sendRouteColors = () => {
        const routeColors = this.state.routes.map((route) => {
            return { ressNr: route.ressNr, color: route.color || this._util.getColor(route.id) } as RouteColors;
        });
        this._srService.sendRouteColors(routeColors);
    }

    activateLiveLocation = (toggleState: boolean) => {
        const routeIds = this.state.routes.map((route) => {
            return route.id;
        });
        if (this.state.isPerimeterSearchOpen) {
            this.closePerimeterSearch();
        }
        const routesTmp = this.clearRoutes(routeIds);
        this.setState({ routes: routesTmp, isLiveLocation: toggleState }, this._reloadResources);
    }

    updateResourceRoutes = (resourceIDs: Array<string>, start: Date, end: Date, groups: Array<string>) => {
        if (this.props.type === "resourceRoutes") {
            this.cartographer.removeAllMarkers();
            this.cartographer.removeAllRoutingLayers();
            this._initResourceRoutes(resourceIDs, start, end, groups).then((newState: DirectionsAppState) => {
                this.setState({ routes: newState.routes }, () => {
                    this._registerRoutes();
                    //Keine Route für den Container/Arbeitsvorrat
                    this._drawRoutesForEachRouteContainer([1]);
                });
            }, (error) => { console.error(error) });
        }
    }

    componentWillUnmount() {
        this._srService.removeCallback("addPoint", this.addPoint);
        this._srService.removeCallback("setStandardRoute", this.setStandardRoute);
        this._srService.removeCallback("setActiveResourceView", this.setActiveResourceView);
        this._srService.removeCallback("markRouteByRessNr", this.markRouteByRessNr);
        this._srService.removeCallback("removeRouteMarking", this.removeRouteMarking);
        this._srService.removeCallback("updateResourceRoutes", this.updateResourceRoutes);
        this._srService.stop();
        document.body.removeEventListener("click", this.removeContextMenuClasses);
        document.removeEventListener("contextmenu", this.preventOpeningOfContextMenu);
    }

    componentDidMount() {
        this._currentSheet = General.Sheet.Manager.getTopMostVisibleSheet();
        this._currentSheet.events.bindInteraction(SheetInteractionEventType.CanHide, () => { return true; });
        document.body.addEventListener("click", this.removeContextMenuClasses);
        if (this._srService == null) {
            this._srService = new GeomapRPCService(this.props.tabId);
            this._srService.registerCallback("addPoint", this.addPoint);
            this._srService.registerCallback("setStandardRoute", this.setStandardRoute);
            this._srService.registerCallback("setActiveResourceView", this.setActiveResourceView);
            this._srService.registerCallback("markRouteByRessNr", this.markRouteByRessNr);
            this._srService.registerCallback("removeRouteMarking", this.removeRouteMarking);
            this._srService.registerCallback("updateResourceRoutes", this.updateResourceRoutes);
            this._srService.start().done(() => {
                let timeConfig = this._calculateTimespans();
                Promise.all([
                    this._geomapService.getConfig(),
                    Helper.getTranslations(["GeoMap.Route", "GeoMap.Std", "GeoMap.Min", "GeoMap.GeocodeAddressFirst", "GeoMap.AddressNotFound",
                        "GeoMap.MachineNotFound", "GeoMap.ResourceNotFound", "GeoMap.AssignmentNotFound", "Adresse.Adresse", "Ressource.Ressource", "Maschine.Maschine", "Einsatz.Einsatz", "GeoMap.WegpunktAdresse",
                        "GeoMap.WegpunktMaschine", "GeoMap.WegpunktRessource", "GeoMap.WegpunktEinsatz", "GeoMap.WegpunktTicket", "GeoMap.ZeichneRoute", "GeoMap.OptimizeRoute", "GeoMap.EntferneRoute", "GeoMap.MarkiereWegpunkt",
                        "GeoMap.MoveUp", "GeoMap.MoveDown", "GeoMap.EntferneWegpunkt", "GeoMap.RouteNotFound", "GeoMap.AddNewRoute", "GeoMap.DeleteWaypoints", "GeoMap.AssignmentFilter", "GeoMap.PerimeterSearch", "GeoMap.Container",
                        "Adresse.Adresssuche", "Maschine.Maschinensuche", "Ressource.Ressourcensuche", "WebSMS.Assignment.AssignmentSearch", "Vorgang.Ticketsuche", "Vorgang.Ticket", "GeoMap.TooManyElements", "GeoMap.ShowPins", "GeoMap.AddPointFailure",
                        "GeoMap.Traffic", "GeoMap.ShowTraffic", "GeoMap.NoApiKey", "GeoMap.MaximumAmountOfResourcesExceeded", "GeoMap.BestFit", "GeoMap.ContextRoute", "GeoMap.AddNewContainer", "GeoMap.DeleteContainer", "GeoMap.HidePins",
                        "GeoMap.LinkedToPlanningBoard", "GeoMap.ClickToRemove", "GeoMap.ElementsSelected", "GeoMap.ChangeContainerName", "GeoMap.CreateGoogleMapsUrl", "GeoMap.OpenInNewBrowserTab",
                        "GeoMap.CopyToClipboard", "WebSMS.Messages.PleaseEnterValidDateTimes", "GeoMap.PointInTime", "GeoMap.ActiveResourceAssignments", "Einsatz.Container", "GeoMap.FocusPin",
                        "GeoMap.FreePlannedPoint", "GeoMap.SearchAlongRoute", "GeoMap.CopyContainer", "GeoMap.LiveLocation", "GeoMap.GeographicalPlanning", "GeoMap.AssignmentAddressNotGeocoded"])
                ])
                    .then(result => {
                        const geomapConfig = result[0] as GeomapConfig;
                        const translations = result[1].Data;
                        this._setDialogProps(translations);
                        if (!Helper.hasValue(this._currentSheet.getTitle()) && this.props.tabId.substring(0, 3) !== "PB_")
                            this._currentSheet.setTitle(translations["GeoMap.GeographicalPlanning"]);
                        let metaDataAdditional = geomapConfig.additional.objects.filter((v) => v.name == "rightDrawerContainer");
                        this._rightDrawerContainer = metaDataAdditional.length > 0 ? metaDataAdditional[0].data as any : null;
                        try {
                            GeomapUtil.init(geomapConfig.containerColors);
                        }
                        catch (error) {
                            console.info(error);
                        }
                        this._util = GeomapUtil.getInstance();
                        this.setState({
                            routes: this.props.type === "resourceRoutes" ? this.state.routes : [{ id: 1, waypoints: [], name: translations["GeoMap.Container"] + " 1" }],
                            pinConfig: geomapConfig.pinTypes,
                            translations: translations,
                            resourceFilterTimeSpanStart: timeConfig.startResourceFilter,
                            resourceFilterTimeSpanEnd: timeConfig.endResourceFilter,
                            perimeterTimeSpanStart: timeConfig.startPerimeterSearch,
                            perimeterTimeSpanEnd: timeConfig.endPerimeterSearch
                        }, () => {
                            this._registerRoutes();
                            if (this.props.tabId.substring(0, 3) === "PB_") {
                                NotificationHelper.showInfoMessage(this.state.translations["GeoMap.LinkedToPlanningBoard"]);
                            }
                        });
                    }, () => {
                        console.error("Error loading config/translations");
                    });
            });
        }
        if (!this.props.schedulerView) {
            General.Events.bind(EventType.SheetRemoved, General.Drawer.Left.close);
            General.Drawer.Left.close();
        }
    }

    private _initResize = () => {
        this.resizeObserver = new ResizeObserver((entries) => {
            entries.forEach(item => {
                const geomapCssUpdate = $('#geomap__directions');
                if (geomapCssUpdate.length > 0) {
                    geomapCssUpdate.css({ maxHeight: item.contentRect.height - 97 - 20 });
                }
                return;
            });
        });
    }

    private setResultRef = (resultRef) => {
        this.resultRef = resultRef;
        if (resultRef) {
            this.resizeObserver.observe(resultRef);
            $(window).trigger("selectEventOnOpen");
        }
    }
    render() {
        if (this.state.translations != null && this._googleMapsUrlDialogProps != null) {
            let textBoxProps = ComponentHelper.createFactory().getDefaultTextBoxProps();
            textBoxProps.value = this.state.googleMapsLinkUrl || "";
            textBoxProps.disabled = true;
            const perimeterSearch = this.state.isPerimeterSearchOpen ? <PerimeterSearchControls refFunction={this.sliderRefFunction} sliderField={this._createSliderField("distance")} value={this.state.distance}
                resultButtonClicked={this.openPerimeterSearchResults} closeButtonClicked={this.closePerimeterSearch} onChange={this._sliderChanged}></PerimeterSearchControls> : null;
            return (<>
                {this._renderRightDrawerComponent()}
                <div className="flex-container" ref={(ref) => { this.setResultRef(ref); }}>
                    <div className="flex-container__item">
                        <GoogleMapsMap mapCreated={this.handleMapCreated} translations={this.state.translations} enableTrafficInformation={true} pinConfig={this.state.pinConfig} rightClickHandler={this.mapRightClicked}> </GoogleMapsMap>
                    </div>
                    <div>
                        <DirectionsDisplay setDirectionsDiv={this.setDirectionsDiv} translations={this.state.translations} newRoute={this.createRouteAndGetRoutesCopy}
                            openResourceFilter={this.openResourceFilter} showFilter={this._resourceRoutesView} newContainerView={this.newContainerView}
                            newActiveResourceAssignmentsView={this.newActiveResourceAssignmentsView} toggleLiveLocation={this.activateLiveLocation}>
                            {this._getRouteComponents(this.state.routes)}
                        </DirectionsDisplay>
                    </div>
                    {this._getPinElements()}
                    {perimeterSearch}
                </div>
                <Dialog {...this._googleMapsUrlDialogProps} ref={this._setGoogleMapsUrlDialogRef}>
                    <TextBox {...textBoxProps} ref={this._setTextBoxRef}></TextBox>
                </Dialog>
                <Dialog {...this._timeSpanFilterDialogProps} open={this.state.timeSpanFilterOpen}>
                    <TimeSpanFilter dateTimeChanged={this.dateTimeChanged} startDate={this.state.resourceFilterTimeSpanStart} endDate={this.state.resourceFilterTimeSpanEnd}
                        modelDP1={DirectionsDialogModelType.ResourceFilterStart} modelDP2={DirectionsDialogModelType.ResourceFilterEnd} nameDP1={Config.translations.from} nameDP2={Config.translations.to}></TimeSpanFilter>
                </Dialog>
                <Dialog {...this._containerViewDialogProps} open={this.state.containerViewDialogOpen}>
                    <TimeSpanFilter dateTimeChanged={this.dateTimeChanged} startDate={this.state.containerViewTimeSpanStart} endDate={this.state.containerViewTimeSpanEnd}
                        modelDP1={DirectionsDialogModelType.ContainerViewStart} modelDP2={DirectionsDialogModelType.ContainerViewEnd} nameDP1={Config.translations.from} nameDP2={Config.translations.to}></TimeSpanFilter>
                </Dialog>
                <Dialog {...this._activeResourceAssignmentsViewDialogProps} open={this.state.activeResourceAssignmentsViewDialogOpen}>
                    <TimeSpanFilter dateTimeChanged={this.dateTimeChanged} startDate={this.state.activeResourceAssignmentsViewTimestamp}
                        modelDP1={DirectionsDialogModelType.ActiveResourceAssignmentsViewTimestamp} nameDP1={this.state.translations["GeoMap.PointInTime"]} ></TimeSpanFilter>
                </Dialog>
                {this._buildMapContextMenu()}
            </>);
        }
        return null;
    }
}

export interface DirectionsCommonProps extends React.PropsWithChildren {
    translations: any;
}

export enum DirectionsDialogModelType {
    ResourceFilterStart = "ResourceFilterStart",
    ResourceFilterEnd = "ResourceFilterEnd",
    ContainerViewStart = "ContainerViewStart",
    ContainerViewEnd = "ContainerViewEnd",
    ActiveResourceAssignmentsViewTimestamp = "ActiveResourceAssignmentsViewTimestamp"
}

export interface AssignmentView {
    Id: string,
    ProjNr: string,
    PIndex: number,
    RessNr: string,
    Name: string,
    Vorname: string,
    Kennung: string,
    AdrName: string,
    Strasse: string,
    Ort: string,
    Plz: string,
    Land: string,
    Bemerkung: string,
    StartIst?: Date,
    EndeIst?: Date,
    AdrNr: string,
    Laengegrad?: number,
    Breitegrad?: number,
    Distance?: number,
    Kennwort: string,
    ContinuationJourney?: number
}

export interface DirectionsConfig {
    Id1: string;
    Id2: number;
    Type: string;
    ResourceIds: Array<string>;
    Groups: Array<string>;
    SortAfterOptimisation: boolean;
    ResourceFilterDaysBefore: number;
    ResourceFilterDaysAfter: number;
    PerimeterDaysBefore: number;
    PerimeterDaysAfter: number;
    SliderMax: number;
    SliderSmallStep: number;
    SliderLargeStep: number;
    Start: string;
    End: string;
    FromPB: boolean;
    PointInfo: any;
    UseMiles: boolean;
    MinimumClusterSize: number;
    ClusterGridSize: number;
    MaxContainerSize: number;
    SearchAlongRouteAvailable: boolean;
}

export interface SignalR {
    geomapHub: GeomapHubProxy;
}

export interface GeomapHubProxy {
    client: GeomapSRClient;
    server: GeomapSRServer;
    qs: any;
}

export interface GeomapSRClient {
    addPoint(point: PointInfo, routeId?: number): JQueryPromise<any>;
    setStandardRoute(result: ResourceRouteContainer, drawRoute?: boolean): JQueryPromise<any>;
    setActiveResourceView(start: Date, end?: Date): void;
    markRouteByRessNr(ressNr: string): void;
    removeRouteMarking(): void;
    receiveRouteColors(): Array<RouteColors>;
}

export interface GeomapSRServer {
    addPoint(point: PointInfo, tab: string, routeId?: number): JQueryPromise<void>;
    registerRoutes(routes: Array<{ routeId: number, name: string }>): JQueryPromise<any>;
    getRouteOrTabCount(): JQueryPromise<any>;
    isDisconnected(): boolean;
    setStandardRoute(ressNr: string, start: Date, end: Date, userName: string, language: number): JQueryPromise<any>;
    setAssignmentAsStandardRoute(projNr: string, pIndex: number, userName: string, language: number): JQueryPromise<any>;
    setSlotStandardRoute(fromRessNrOrAssignmentGuid: string, slotGuid: string, userName: string, language: number): JQueryPromise<any>;
    setAssignmentRouteAsStandardRoute(projNr: string, pIndex: number, userName: string, language: number): JQueryPromise<any>;
    addActiveResourceAssignmentsContainer(start: Date, end?: Date): JQueryPromise<any>;
    markRouteByRessNr(ressNr: string): JQueryPromise<any>;
    removeRouteMarking(): JQueryPromise<any>;
    sendRouteColors(colors: Array<RouteColors>): JQueryPromise<any>;
}

export interface DirectionsAppProps {
    context: Object;
    title: string;
    type: string;
    id1: string;
    id2: number;
    resourceIDs: Array<string>;
    groups: Array<string>;
    sortAfterOptimisation: boolean;
    resourceFilterDaysBefore: number;
    resourceFilterDaysAfter: number;
    perimeterDaysBefore: number;
    perimeterDaysAfter: number;
    sliderMax?: number;
    sliderSmallStep?: number;
    sliderLargeStep?: number;
    tabId?: string;
    start?: Date;
    end?: Date;
    pointInfo?: PointInfo;
    useMiles: boolean;
    minimumClusterSize?: number;
    clusterGridSize?: number;
    maxContainerSize?: number;
    searchAlongRouteAvailable: boolean;
    schedulerView: boolean;
}

export interface DirectionsAppState {
    routes: Array<RouteObject>;
    translations?: any;
    resourceFilterTimeSpanStart?: Date;
    resourceFilterTimeSpanEnd?: Date;
    gridOptions?: any;
    addressGridData?: any;
    perimeterSearchMarkerIDs?: Array<string>;
    perimeterTimeSpanStart?: Date;
    perimeterTimeSpanEnd?: Date;
    distance?: number;
    choosenLat?: number;
    choosenLng?: number;
    isPerimeterSearchTransparent?: boolean;
    isPerimeterSearchOpen?: boolean;
    googleMapsLinkUrl?: string;
    pinConfig?: any;
    containerViewTimeSpanStart?: Date;
    containerViewTimeSpanEnd?: Date;
    activeResourceAssignmentsViewTimestamp?: Date;
    timeSpanFilterOpen?: boolean;
    containerViewDialogOpen?: boolean;
    activeResourceAssignmentsViewDialogOpen?: boolean;
    currentContextMenuPos?: { x: number, y: number };
    currentLatLngOfMarkerToAdd?: google.maps.LatLng;
    isLiveLocation: boolean;
}

export interface GeomapParameterContainer {
    geomapType: string;
    parameterString: string;
    dateParameters: string;
    geomapResourceViewParamObject: GeomapResourceViewParam;
}

export interface GeomapResourceViewParam {
    resourceIDs: string[];
    start: Date;
    end: Date;
    groups: string[];
}

interface ResourceRouteContainer {
    resource: any;
    assignments: any;
    backHome?: boolean;
    fromHome?: boolean;
}